<template>
  <form>
    <article class="new-collection__wrapper">
      <input
        type="text"
        ref="extraField"
        style="display: none"
        tabindex="-1"
        autocomplete="off"
      />

      <div>
        <label>Namnge</label>
        <input v-model="title" placeholder="Döp din insamling" />
      </div>

      <div>
        <label>Mål i kronor</label>
        <input type="number" v-model="goal" placeholder="Summa" />
      </div>
    </article>

    <article class="new-collection__wrapper">
      <div>
        <label>Namn</label>
        <input v-model="author" placeholder="Ditt namn" />
      </div>

      <div>
        <label>E-post</label>
        <input placeholder="Din e-post" v-model="email" />
      </div>
    </article>

    <div class="new-collection__end-date">
      <label>Slutdatum</label>
      <input type="date" v-model="endDate" />
    </div>

    <div class="green collection-modal" v-if="success">
      <div class="collection-modal__inner">
        <h2>Grattis till din insamling</h2>
        <p>
          Vi återkommer inom kort med en länk du kan dela i t.ex. sociala medier
        </p>
        <a :href="modalLink.url">{{ modalLink.title }}</a>
      </div>
    </div>

    <div v-if="targets" class="new-collection__targets">
      <label>Välj ändamål</label>
      <div>
        <select v-model="target">
          <option selected disabled value="">Välj ändamål</option>
          <option
            v-for="target in pledgeTargets"
            :key="target.kommed_id"
            :value="target.kommed_id"
          >
            {{ target.post_title }}
          </option>
        </select>
      </div>
    </div>

    <div class="new-collection__motivation">
      <textarea v-model="motivation"></textarea>
    </div>

    <div class="new-collection__images">
      <label>Välj en omslagsbild</label>
      <div class="new-collection__images--wrapper">
        <label :key="imageUrl" v-for="imageUrl in images">
          <input type="radio" name="image" :value="imageUrl" v-model="image" />
          <img :src="imageUrl" width="100" />
        </label>
      </div>
    </div>

    <div class="red" v-if="error">
      <p>{{ error }}</p>
    </div>

    <div class="new-collection__submit">
      <button type="button" @click="createCollection">Skapa insamling</button>
      <p>När din insamling blivit godkänd så kommer du få en länk till din mejl.</p>
    </div>
  </form>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Collection',

  props: {
    wpNonce: {
      type: String,
      default: null,
    },
    wpAjax: {
      type: String,
      default: '/wp-admin/admin-ajax.php',
    },
    url: {
      type: String,
      required: true,
    },
    images: {
      type: Array,
      default: null,
    },
    modalLink: {
      type: Array,
      default: null,
    },
    pledgeTargets: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      targets: [],
      error: null,
      success: null,
      target: null,
      goal: null,
      endDate: null,
      author: null,
      image: null,
      email: null,
      title: null,
      motivation: null,
    };
  },

  async mounted() {
    await this.getTargets();

    if (this.pledgeTargets.length && !this.target) {
      setTimeout(() => {
        this.target = this.pledgeTargets[0].kommed_id;
      }, 500)
    }
  },

  methods: {
    async getTargets() {
      const form = new FormData();
      form.append('nonce', this.wpNonce);
      form.append('action', 'collections_targets');
      try {
        const {
          data: { targets },
        } = await axios.post(this.wpAjax, form);
        this.targets = { ...targets };
      } catch (e) {
        console.warn('could not get targets', e);
      }
    },

    async createCollection() {
      let extraFieldValue = this.$refs.extraField.value;
      if (extraFieldValue) {
        return;
      }

      this.success = null;
      this.error = null;
      const translations = {
        image: 'bild',
        author: 'ditt namn',
        title: 'titel',
        target: 'ändamål',
        email: 'e-post',
        goal: 'mål i kronor',
      };
      const fields = [
        'image',
        'author',
        'title',
        'target',
        'email',
        'goal',
        'motivation',
      ];
      const missing = [];

      for (let field of fields) {
        if (this[field] === null) {
          missing.push(translations[field] || field);
        }
      }

      if (missing.length) {
        const missingFieldsTranslated = missing.map(
          (field) => translations[field] || field,
        );
        const errorMessage = `Följande fält saknas: ${missingFieldsTranslated.join(
          ', ',
        )}`;
        this.error = errorMessage;
        return;
      }
      const form = new FormData();
      for (let f in fields) {
        form.append(fields[f], this[fields[f]]);
      }
      form.append('end_date', this.endDate);
      form.append('action', 'create_collection');
      form.append('nonce', this.wpNonce);
      form.append('form_url', this.url);
      try {
        const { data } = await axios.post(this.wpAjax, form);
        console.log(data);
        this.success = `${this.url}?cid=${data.collection_id}`;
      } catch (e) {
        this.error = 'could not create collection';
        console.warn('could not create collection', e);
      }
    },

    copyLink() {
      navigator.clipboard.writeText(this.success);
    },
  },
};
</script>

<style scoped>
.red {
  color: red;
}
.green {
  color: green;
}
</style>
